/**
 * SpellManagerContainer - Container Component for SpellManager
 *
 * Container component responsible for:
 * - Zustand store connection for the global spells cache
 * - Accepting passthrough props (items, onChange) from the parent (CharacterSheetTabs)
 * - Delegating presentation to the pure SpellManager component
 *
 * This follows the Container/Presenter pattern as defined in ADR-034.
 * @see docs/adr/0034-container-presenter-component-pattern.md
 */

import React from 'react';
import { useStore } from '../../hooks/useStore';
import SpellManager from './SpellManager';
import type { SpellManagerPassthroughProps } from './SpellManager';

const SpellManagerContainer: React.FC<SpellManagerPassthroughProps> = (passthroughProps) => {
  // ---------------------------------------------------------------------------
  // Store Connection - Container Responsibility
  // ---------------------------------------------------------------------------
  const allSpells = useStore(state => state.session?.cache?.spells);

  // ---------------------------------------------------------------------------
  // Render: Delegate to Presenter
  // ---------------------------------------------------------------------------
  return (
    <SpellManager
      {...passthroughProps}
      allSpells={allSpells}
    />
  );
};

export default SpellManagerContainer;
